export default "__VITE_ASSET__C43uZ15R__"